module.exports = __webpack_public_path__ + "72340d457724bc7e5d02751dce18aa99.mp4";